<template>
  <div class="b-r-3 RightCard">
    <div id="time1">
      <div class="LastSubmitDate">
        {{ $t('lbl_EMPBE_ProductInfo_SubmitTime') }}
      </div>
      <div class="LastSubmitDateVals">
        {{ submitDateDisplay }}
      </div>
    </div>
    <div class="LastDate">
      <div>
        <div class="LastSubmitDate">
          {{ $t('lbl_EMPBE_ProductInfo_ApprovalTime') }}
        </div>
        <div class="LastSubmitDateVals">
          {{ approvalDateDisplay }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProInfoUpdateTime',
  props: {
    /** 提交时间 */
    submitDate: { type: [String, Date, Number], default: '' },
    /** 审批时间 */
    approvalDate: { type: [String, Date, Number], default: '' },
    /** 兼容旧用法 */
    lastUpdateDate: { type: [String, Date, Number], default: '' },
    lastSubmitDate: { type: [String, Date, Number], default: '' },
  },
  computed: {
    submitDateDisplay() {
      return this.formatSideTime(this.submitDate || this.lastSubmitDate);
    },
    approvalDateDisplay() {
      return this.formatSideTime(this.approvalDate || this.lastUpdateDate);
    },
  },
  methods: {
    formatSideTime(value) {
      if (value == null || value === '') return '-';
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        const y = value.getFullYear();
        const m = String(value.getMonth() + 1).padStart(2, '0');
        const d = String(value.getDate()).padStart(2, '0');
        const hh = String(value.getHours()).padStart(2, '0');
        const mm = String(value.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${d} ${hh}:${mm}`;
      }
      const raw = String(value).trim();
      if (!raw || raw === '-') return '-';
      // 常见 "yyyy-MM-dd HH:mm:ss" → 去掉秒
      if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}/.test(raw)) {
        return raw.replace('T', ' ').substring(0, 16);
      }
      if (raw.length > 16) return raw.substring(0, 16);
      return raw;
    },
  },
};
</script>
<style lang="scss" scoped>
.RightCard {
  padding: 16px 8px;
  border-radius: 24px !important;
  gap: 8px;
  display: grid;
}
.LastDate {
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
}
.LastSubmitDate {
  color: var(--On-Surface-40, rgba(0, 0, 0, 0.4));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.154px;
}
.LastSubmitDateVals {
  color: var(--On-Surface-60, rgba(0, 0, 0, 0.6));
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.154px;
}
.card .card-body {
  padding: 0px;
  background-color: transparent;
}
</style>
